/**
 * Device detector is a simple vue plugin to inspect the device type.
 * https://github.com/dreambo8563/vue-device-detector#readme
 */

import Vue from 'vue';
import device from 'vue-device-detector';

Vue.use(device);
